import { Flex } from "@redotech/arbiter/flex";
import { RedoListItem } from "@redotech/arbiter/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/arbiter/select-dropdown/redo-single-select-dropdown-input";
import { Text } from "@redotech/arbiter/text";
import {
  listOverboxFulfillmentCenters,
  OverboxService,
} from "@redotech/redo-fulfillment-operations-common/overboxing";
import { Input } from "@redotech/ui/form";
import { memo, useMemo } from "react";

export const OverboxFulfillmentCenterSelect = memo(
  function OverboxFulfillmentCenterSelect({
    input,
    service,
  }: {
    input: Input<string | null>;
    service: OverboxService;
  }) {
    const options: RedoListItem<string>[] = useMemo(
      () =>
        listOverboxFulfillmentCenters(service).map((fc) => ({
          id: fc.id,
          type: "text" as const,
          text: fc.label,
          value: fc.id,
        })),
      [service],
    );

    const selectedItem = useMemo(
      () => options.find((o) => o.value === input.value),
      [options, input.value],
    );

    return (
      <Flex dir="column" gap="sm" mt="md" w="sm">
        <Text fontSize="xs" fontWeight="medium">
          Fulfillment center
        </Text>
        <RedoSingleSelectDropdownInput<string>
          options={options}
          optionSelected={({ item }) => {
            input.setValue(item.value);
          }}
          placeholder={
            options.length === 0
              ? "No fulfillment centers configured"
              : "Select fulfillment center"
          }
          selectedItem={selectedItem}
          size="xs"
        />
      </Flex>
    );
  },
);
